import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ModalTitleContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));
